import { FormattedMessage } from "react-intl";

import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { TranslationHelper } from "app/helpers/translationHelper";
import { BetSlipType } from "app/types/betSlipType";
import { EventMarketType } from "app/types/eventType";
import { MarketPeriods, SportsNameType } from "app/utils/const";

/**
 * Props for the PeriodName component.
 * @typedef {Object} Props
 * @property {BetSlipType} betSlip The bet slip object.
 */

type Props = {
  betSlip: BetSlipType;
};

/**
 * The PeriodName component displays the name of the period for a given bet slip.
 * It first checks for specific market/period combinations and if not found, it uses
 * the market period to determine the period name.
 * Extracted this code from betslip content
 *
 * @param {Props} props The component props.
 * @returns {React.ReactNode} The JSX element for the period name.
 */
const PeriodName: React.FC<Props> = ({ betSlip }) => {
  const betSlipMarket: EventMarketType | null =
    BetSlipHelper.getBetSlipMarket(betSlip);
  // first check for specific market/period combinations
  if (betSlipMarket) {
    const id = TranslationHelper.getMarketNameSuffix(
      betSlipMarket.type,
      betSlipMarket.period,
      betSlip.sportType
    );

    if (id !== "markets-suffix-blank") {
      return <FormattedMessage tagName="span" id={id} />;
    } else {
      //  markets-suffix-blank here means that there is no suffix returned from getMarketNameSuffix
      //  so use getTranslationIdForMarket instead to determine if Full Time, First Half etc should be shown
      //  BUT a market period is passed instead of a marketType..
      return (
        <div>
          {betSlip.sportType !== SportsNameType.BOXING && (
            <span>
              (
              {betSlipMarket &&
                (betSlipMarket.period === MarketPeriods.SECOND_HALF ? (
                  <FormattedMessage
                    tagName="span"
                    id={TranslationHelper.getTranslationIdForMarket(
                      MarketPeriods.SECOND_HALF
                    )}
                  />
                ) : (
                  <FormattedMessage
                    tagName="span"
                    id={TranslationHelper.getTranslationIdForMarket(
                      betSlipMarket.period
                    )}
                  />
                ))}
              )
            </span>
          )}
        </div>
      );
    }
  }
};

export default PeriodName;
